import { api } from './client';

export interface CheckAccessResponse {
  enabled: boolean;
  allowed: boolean;
  interest_registered: boolean;
  email: string;
}

export interface RegisterInterestResponse {
  ok: boolean;
  already_registered: boolean;
  email: string;
}

export async function checkOnboardingAccess(): Promise<CheckAccessResponse> {
  const { data } = await api.get<CheckAccessResponse>('/onboarding/check-access');
  return data;
}

export async function registerOnboardingInterest(): Promise<RegisterInterestResponse> {
  const { data } = await api.post<RegisterInterestResponse>('/onboarding/register-interest');
  return data;
}
